import React from 'react';
import { Grid, GridItem } from '@chakra-ui/react';
import SummaryCards from '../components/SummaryCards';
import SalesCompositionCard from '../components/SalesCompositionCard';
import SalesMonthlyCard from '../components/SalesMonthlyCard';

const AviationServicesSection = (props) => {
  const {
    memberSummaryLoading,
    memberSummary,
    memberLabels,
    chartLoading,
    chartData,
    COLORS,
    surfaceCard,
    DASHBOARD_TYPE,
    DASHBOARD_SURFACE,
    formatNumber,
    formatCurrency,
    formatPercentage,
  } = props;

  return (
    <Grid templateColumns="1fr" gap={5}>
      <GridItem>
        <SummaryCards
          memberSummaryLoading={memberSummaryLoading}
          memberSummary={memberSummary}
          selectedMember="AVIATION_SERVICES"
          memberLabels={memberLabels}
          DASHBOARD_TYPE={DASHBOARD_TYPE}
          DASHBOARD_SURFACE={DASHBOARD_SURFACE}
          surfaceCard={surfaceCard}
          formatNumber={formatNumber}
          formatCurrency={formatCurrency}
          formatPercentage={formatPercentage}
        />
      </GridItem>

      <GridItem>
        <SalesCompositionCard
          mode="aviation"
          title={memberLabels.compositionTitle}
          chartLoading={chartLoading}
          chartData={chartData}
          COLORS={COLORS}
          surfaceCard={surfaceCard}
          DASHBOARD_TYPE={DASHBOARD_TYPE}
          formatCurrency={formatCurrency}
          formatNumber={formatNumber}
        />
      </GridItem>

      <GridItem>
        <SalesMonthlyCard
          mode="aviation"
          title={memberLabels.monthlySalesTitle}
          chartLoading={chartLoading}
          chartData={chartData}
          COLORS={COLORS}
          surfaceCard={surfaceCard}
          DASHBOARD_TYPE={DASHBOARD_TYPE}
          formatCurrency={formatCurrency}
        />
      </GridItem>
    </Grid>
  );
};

export default AviationServicesSection;
